import React from 'react';
import { logoNameMap } from '../../../assets/SVGs/logos/Logo';
import { useTheme } from '../../../context/ThemeContext';

interface DonationHeaderProps {
  hospitalName?: string;
  subtitle?: string;
}

const DonationHeader: React.FC<DonationHeaderProps> = ({
  hospitalName = "",
  subtitle = ""
}) => {
  const { theme } = useTheme();
  const IconComponent = logoNameMap[theme.logo];
  return (
    <header className="w-full bg-white shadow-sm">
      <div className="mx-auto px-6 py-5 lg:px-6 lg:py-5">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
          {/* Left side - Hospital info */}
          <div className="flex items-center gap-3">
            {/* Hospital icon */}
            <div className="h-10 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
              <IconComponent width={150} />
            </div>
            
            {/* Hospital name and subtitle */}
            <div className="flex flex-col">
              <h1 className="text-xl lg:text-xl font-bold text-gray-800 leading-tight pl-2">
                {hospitalName}
              </h1>
              <p className="text-sm lg:text-sm text-gray-500">
                {subtitle}
              </p>
            </div>
          </div>

          {/* Right side - Additional content can be added here */}
          {/* <div className="flex-shrink-0">
          </div> */}
        </div>
      </div>
    </header>
  );
};

export default DonationHeader; 